import React from "react";
import { Text, View } from "@react-pdf/renderer";

const AccessAndNotes = () => {
  return (
    <View
      wrap={false}
      style={{
        border: "2px solid black",
        fontSize: "8px",
        marginTop: "10px",
        paddingHorizontal: "5px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <View style={{ width: "98%", borderRight: "1px solid black" }}>
        <Text style={{ fontSize: "10px", marginBottom: "5px" }}>
          Zubehör und Bemerkungen zum Gerät
        </Text>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: "10px",
          }}
        >
          <Text>Bemerkungen</Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>1</Text>
          <Text>
            -zerlegte Anlieferung, Montage auf der Baustelle ( excl. Ablad,
            Einbringung und interne Baustellentransporte )
          </Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>1</Text>
          <Text>-liegende Ausführung</Text>
        </View>
      </View>
      <View
        style={{
          width: "2%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          paddingLeft: "2px",
        }}
      >
        <Text>3</Text>
      </View>
    </View>
  );
};

export default AccessAndNotes;
